import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DataUnitOPEEnum} from "./DataUnitOPEEnum";

class DataUnitDTO {
  id!: number;
  name!: string;
}

class O {
  metricInstances!: DataUnitDTO[];
}

/**
 * O Inner Class
 */
class I {

}

export class GetDataUnitsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DataUnitOPEEnum.GetDataUnits);
    this.i = new I();
    this.o = new O();
  }
}
